module.exports = __webpack_public_path__ + "static/media/Style9.fa21cc68.PNG";